import i18n from '../i18n'

export type ErrorCode =
  | 'AUTH_INVALID_CREDENTIALS'
  | 'AUTH_USER_NOT_FOUND'
  | 'AUTH_ACCOUNT_INACTIVE'
  | 'AUTH_OTP_INVALID'
  | 'AUTH_OTP_EXPIRED'
  | 'AUTH_TOKEN_MISSING'
  | 'AUTH_TOKEN_INVALID'
  | 'AUTH_FORBIDDEN'
  | 'RATE_LIMITED'
  | 'VALIDATION_ERROR'
  | 'COMPANY_MODULE_LIMIT_REACHED'
  | 'COMPANY_SIGNUP_FAILED'
  | 'INTERNAL_ERROR'

const messageKeys: Record<ErrorCode, string> = {
  AUTH_INVALID_CREDENTIALS: 'errors.authInvalidCredentials',
  AUTH_USER_NOT_FOUND: 'errors.authUserNotFound',
  AUTH_ACCOUNT_INACTIVE: 'errors.authAccountInactive',
  AUTH_OTP_INVALID: 'errors.authOtpInvalid',
  AUTH_OTP_EXPIRED: 'errors.authOtpExpired',
  AUTH_TOKEN_MISSING: 'errors.authTokenMissing',
  AUTH_TOKEN_INVALID: 'errors.authTokenInvalid',
  AUTH_FORBIDDEN: 'errors.authForbidden',
  RATE_LIMITED: 'errors.rateLimited',
  VALIDATION_ERROR: 'errors.validationError',
  COMPANY_MODULE_LIMIT_REACHED: 'errors.companyModuleLimitReached',
  COMPANY_SIGNUP_FAILED: 'errors.companySignupFailed',
  INTERNAL_ERROR: 'errors.internalError',
}

export function knownErrorCodeMessage(code?: string): string | undefined {
  if (!code) return undefined
  const key = (messageKeys as Record<string, string>)[code]
  return key ? i18n.t(key) : undefined
}

export function mapErrorCodeToMessage(code?: string, fallback?: string) {
  return knownErrorCodeMessage(code) || fallback || i18n.t('errors.generic')
}
